import React, { useCallback, useMemo } from 'react'
import DebouncedInput from '../../../../molecules/DebouncedInput'
import { useSyncedTransactions } from './SyncedTransactionsProvider'
import { deriveTextSearchFields } from './columnDefs'

const inputStyle = {
  minWidth: '360px',
  maxWidth: '540px'
}

const FIELD_LABELS = {
  ticker: 'ticker',
  productname: 'product',
  notes: 'notes',
  accountName: 'account name',
  accountNumber: 'account number',
  accountLongName: 'account long name',
  cusip: 'cusip',
  transactionTypeName: 'transaction type'
}

function buildPlaceholder (fields) {
  const labels = fields.map(f => FIELD_LABELS[f] ?? f)
  if (!labels.length) return 'Search...'
  return `Search ${labels.join(', ')}...`
}

export default function SyncedTransactionsTextSearch () {
  const { columns, onSearchChange } = useSyncedTransactions()

  const placeholder = useMemo(() => buildPlaceholder(deriveTextSearchFields(columns)), [columns])

  const handleChange = useCallback((value) => {
    onSearchChange(value ?? '')
  }, [onSearchChange])

  return (
    <DebouncedInput
      placeholder={placeholder}
      delay={350}
      onChange={handleChange}
      style={inputStyle}
    />
  )
}
